export default __webpack_public_path__ + "static/media/004-feather-red.15d6ce8d.svg";